import TooltipCustom from 'ui/atoms/Tooltip/Tooltip';
import DialogSelectSessions from 'core/modules/components/dialogs/DialogSelectSessions/DialogSelectSessions';
import PropTypes from 'prop-types';
import React from 'react';
import { Tag } from 'ui';
import useSessionsTag from './useSessionsTag';

function SessionsTag({ canEditSessions, courseGuid, lessonGuid, lessonItemGuid, onSaveSessions, sessions }) {
  const {
    additionalSessionsButtonClassName,
    additionalSessionsCount,
    additionalSessionsHasPopup,
    additionalSessionsLabel,
    additionalSessionsTagLabel,
    allSessionsText,
    editSessionsLabel,
    firstSessionText,
    loading,
    onClickChangeSessions,
    onCloseDialog,
    onSuccessDialog,
    openDialog,
    shouldShowEditableSession,
    shouldShowReadOnlySession,
  } = useSessionsTag({ canEditSessions, lessonItemGuid, onSaveSessions, sessions });

  return (
    <div className="sessions-tag" data-testid="sessions-tag">
      {shouldShowEditableSession && (
        <button
          aria-haspopup="dialog"
          aria-label={editSessionsLabel}
          className="button-accessibility-only sessions-tag__tag sessions-tag__tag--clickable"
          data-testid="first-session-tag"
          onClick={onClickChangeSessions}
          type="button"
        >
          <Tag label={firstSessionText} leftIcon="calendar" />
        </button>
      )}

      {shouldShowReadOnlySession && (
        <div className="sessions-tag__tag" data-testid="first-session-tag">
          <Tag label={firstSessionText} leftIcon="calendar" />
        </div>
      )}

      {additionalSessionsCount > 0 && (
        <div className="sessions-tag__extra">
          <TooltipCustom hasArrow placement="top" title={allSessionsText}>
            <button
              aria-haspopup={additionalSessionsHasPopup}
              aria-label={additionalSessionsLabel}
              className={additionalSessionsButtonClassName}
              data-testid="additional-sessions-tag"
              onClick={onClickChangeSessions}
              type="button"
            >
              <Tag label={additionalSessionsTagLabel} />
            </button>
          </TooltipCustom>
        </div>
      )}

      {!!canEditSessions && !!openDialog && (
        <DialogSelectSessions
          open={openDialog}
          onClose={onCloseDialog}
          onSuccessDialog={onSuccessDialog}
          courseGuid={courseGuid}
          lessonGuid={lessonGuid}
          sessions={sessions}
          loading={loading}
        />
      )}
    </div>
  );
}

SessionsTag.propTypes = {
  canEditSessions: PropTypes.bool,
  courseGuid: PropTypes.string,
  lessonGuid: PropTypes.string,
  lessonItemGuid: PropTypes.string,
  onSaveSessions: PropTypes.func,
  sessions: PropTypes.arrayOf(
    PropTypes.shape({
      session_id: PropTypes.string,
      session_order: PropTypes.number,
    })
  ),
};

export default SessionsTag;
